import { numberMoney } from 'Data/format.js'
import { getAdjustedTreatmentFeeAfterInsurances } from 'Data/payment-plan.js'

export function getValue(payment_plan) {
  let amount = getAdjustedTreatmentFeeAfterInsurances(payment_plan)
  return `(${payment_plan.payors.length}) - ${numberMoney(amount)}`
}
